import { BoxContainer } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { JSX } from 'react';
import { CTAInner } from './CTAInner/CTAInner';
import styles from './styles.module.scss';

export type CallToActionProps = SliceComponentProps<Content.CallToActionSlice>;

const CallToAction = ({ slice }: CallToActionProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={styles.box_container}>
        <CTAInner data={slice.primary} />
      </BoxContainer>
    </section>
  );
};

export default CallToAction;
